import __NS_DYNAMIC_REACT_CONTENT___0 from "./env-chooser.strings/content.default.js";
import { Content, createScopedReactContentImporter } from "packages/react-content/runtime";
const NS_DYNAMIC_REACT_CONTENT_MANAGER = createScopedReactContentImporter(undefined, {
  "default": () => __NS_DYNAMIC_REACT_CONTENT___0
});
import { FormSubmitButton } from 'legos/button/form-submit';
import { ButtonRaised } from 'legos/button/raised';
import { SystemIcon } from 'legos/system-icon';
import { UnknownField } from 'legos/text-field/unknown';
import { Helper, Disclosure } from 'legos/typography';
import { useLocation } from 'packages/react-nano-router';
import { createElement, Fragment } from 'react';
import { Form } from 'react-final-form';
import { useEnvChooserContext } from './context';
import { Container, MarginTop } from './styles/env-chooser.ccm.css';
import { CenterChildren } from 'apps/acp/packages/center-children';
export const EnvChooser = () => {
  const {
    href
  } = useLocation();
  const {
    setEnvChooserVisible
  } = useEnvChooserContext();
  return createElement(Fragment, null, createElement(Disclosure, {
    style: {
      margin: '10px',
      float: 'right'
    },
    title: "closeX",
    onClick: () => setEnvChooserVisible(false)
  }, createElement(SystemIcon, {
    type: "closeX",
    size: 2.0
  })), createElement(Container.div, null, createElement(CenterChildren, null, createElement(Helper, null, createElement(Content, {
    hash: "26425a7323f9786b5207c193c51d9178",
    devVariables: {},
    componentsAndExpressions: [],
    importer: NS_DYNAMIC_REACT_CONTENT_MANAGER
  })), createElement(Helper, {
    style: {
      wordBreak: 'break-all'
    }
  }, href), createElement(Helper, null, createElement(Content, {
    hash: "1a0c914c668082034d198cd4419208a2",
    devVariables: {},
    componentsAndExpressions: [],
    importer: NS_DYNAMIC_REACT_CONTENT_MANAGER
  })), createElement(Helper, {
    style: {
      wordBreak: 'break-all'
    }
  }, createElement(Content, {
    hash: "4130c88f257e6c1f1b411725fc5de27e",
    devVariables: {},
    componentsAndExpressions: [],
    importer: NS_DYNAMIC_REACT_CONTENT_MANAGER
  }))), createElement(Form, {
    onSubmit: values => window.location.assign(values.environment)
  }, ({
    handleSubmit
  }) => createElement("form", {
    onSubmit: handleSubmit,
    noValidate: true
  }, createElement(UnknownField, {
    name: "environment",
    label: "Enter an Environment",
    required: true,
    errorRequiredMessage: "Required"
  }), createElement(MarginTop.div, null, createElement(CenterChildren, null, createElement(FormSubmitButton, {
    variant: ButtonRaised,
    color: "positive"
  }, createElement(Content, {
    hash: "ca7e0d1b7a947ee1574dc81b14c72c38",
    devVariables: {},
    componentsAndExpressions: [],
    importer: NS_DYNAMIC_REACT_CONTENT_MANAGER
  }))))))));
};